export default __webpack_public_path__ + "static/media/holding-hands.82ee0193.png";